import api from '../api/properties'
import apiNeighborhood from '../api/neighborhoods'
import { fetchSection, fetchFilteredPropertyTypes } from './api'
import { resetPage } from './meta'
import * as urls from '../constants/api'
import * as tel from '../constants/phones'
import { setListData } from './meta'
import { changeOriginSearch } from './searchBar'
import { pick, paramsForProperties } from './api'
import { browserHistory } from 'react-router'


// Actions
export const actionTypes = {
	SET_LISTTYPE: 'propiedades/SET_LISTTYPE',
  SET_MODALSTATUS: 'propiedades/SET_MODALSTATUS',
  SET_INFOTYPE: 'propiedades/SET_INFOTYPE',
	RECEIVE: 'propiedades/RECEIVE',
  RECEIVE_SIBLINGS: 'propiedades/RECEIVE_SIBLINGS',
  RECEIVE_DETAIL: 'propiedades/RECEIVE_DETAIL',
  RECEIVE_RELATED: 'propiedades/RECEIVE_RELATED',
  RECEIVE_IMPORTANTS: 'propiedades/RECEIVE_IMPORTANTS',
  RECEIVE_RELEVANTS: 'propiedades/RECEIVE_RELEVANTS',
  RECEIVE_NOT_IN_LIST: 'propiedades/RECEIVE_NOT_IN_LIST',
	ERROR: 'propiedades/ERROR',
  LOAD_PROPERTY_TYPES: 'propiedades/LOAD_PROPERTY_TYPES',
  RECEIVE_PROPERTY_TYPES: 'propiedades/RECEIVE_PROPERTY_TYPES',
  RECEIVE_OPERATION_TYPES: 'propiedades/RECEIVE_OPERATION_TYPES',
  LOAD_PROPERTY: 'propiedades/LOAD_PROPERTY',
  LOADING: 'propiedades/LOADING',
  LOADING_DETAIL: 'propiedades/LOADING_DETAIL',
  SET_PLACES: 'propiedades/SET_PLACES',
  RECEIVE_NEIGHBORHOOD_DETAIL: 'propiedades/RECEIVE_NEIGHBORHOOD_DETAIL',
  NOT_RECEIVE_NEIGHBORHOOD_DETAIL: 'propiedades/NOT_RECEIVE_NEIGHBORHOOD_DETAIL',
  SAVE_ORDER: 'propiedades/SAVE_ORDER',
  SAVE_STREETVIEW_STATUS: 'propiedades/SAVE_STREETVIEW_STATUS',
	RESET_PROPERTY_TYPES: 'propiedades/RESET_PROPERTY_TYPES',
  SET_PHONE: 'header/SET_PHONE',
  LOAD_PROPERTIES: 'propiedades/LOAD_PROPERTIES'
}

// Action creators
export const setListType = (value) => {
  return {
    type: actionTypes.SET_LISTTYPE,
    value: value
  }
}

export const searchPropiedades = () => {
  return (dispatch, getStore) => {
    dispatch(resetPage())
    dispatch(load(urls.PROPERTIES))
    dispatch(changeOriginSearch())
  }
}

export const load = (url) => {
  return (dispatch, getStore) => {
    dispatch(loadProperties(getStore()))
    dispatch(resetPage())
    dispatch(loadingResults())
    dispatch(fetchSection(url))
  }
}

export const resetPropertyTypes = () => {
	return {
		type: actionTypes.RESET_PROPERTY_TYPES
	}
}

export const loadFromPagination = () => {
  return (dispatch, getStore) => {
    var properties = getStore().properties
    var meta = getStore().meta
    dispatch(loadingResults())
    dispatch(fetchSection(urls.PROPERTIES))
  }
}

export const get = (params,d) => {
  return (dispatch, getStore) => {
    api.fetchProperties(params,d)
      .then((data) => {
        dispatch(receive(data))
        dispatch(setListData(data))
      })
      .catch((err) => {
        console.error(err)
        dispatch(error(err))
      }
    )
  }
}

function loadingResults() {
  return {
    type: actionTypes.LOADING
  }
}

function receive(APIdata) {
  return {
    type: actionTypes.RECEIVE,
    properties: APIdata.data
  }
}

export const loadProperty = (id) => {
  return (dispatch, getStore) => {
    dispatch(loadingDetail())
    api.fetchPropertiesDetail(id)
      .then((data) => {
        if(data && data.response && data.response.status === 404){
          browserHistory.push('/404')
        } else {
          if (data.has_siblings && ((data.has_siblings === true) || (data.is_root === true))){
            dispatch(loadSiblings(data.property_code))
          }
          if (data.subsidiary_type_id){
            dispatch(setPhone(data.category_type_name, data.subsidiary_type_name, getStore()))
          }
          else{
            dispatch(setPhone(data.category_type_name))
          }
          dispatch(receiveDetail(data))
          dispatch(loadNeighborhoodDetails(data))
        }
      })
  }
}

export const loadSiblings = (id) => {
  return (dispatch, getStore) => {
    api.fetchSiblings(id)
      .then((data) => dispatch(receiveSiblings(data)))
  }
}

export const loadNeighborhoodDetails = (prop) => {
  let id = prop.neighborhood_id
  return (dispatch, getStore) => {
    apiNeighborhood.fetchNeihborhoodsDetail(id)
      .then((data) => dispatch(receiveNeighborhoodsDetail(data)))
  }
}

export const loadRelatedProperties= (id) => {
  return (dispatch, getStore) => {
    api.fetchRelatedProperties(id)
      .then((data) => dispatch(receiveRelated(data)))
  }
}

export const loadImportantProperties = (id) => {
  return (dispatch, getStore) => {
    api.fetchImportantProperties(id, 12)
      .then((data) => dispatch(receiveImportant(data)))
  }
}

export const loadRelevantProperties = (id, property_type_id) => {
  return (dispatch, getStore) => {
    api.fetchRelevantProperties(id, undefined, property_type_id)
      .then((data) => dispatch(receiveRelevants(data, id)))
  }
}

export const loadPropertiesByNeighborhood = (id) => {
  id = parseInt(id)
  return (dispatch, getStore) => {
    api.fetchImportantProperties(id, 4)
      .then((data) => dispatch(receiveImportant(data)))
  }
}

export const loadSimilarProperties= (id) => {
  return (dispatch, getStore) => {
    api.fetchNotInProperties(id, 4)
      .then((data) => dispatch(receiveNotIn(data)))
  }
}

function receiveNeighborhoodsDetail(APIdata) {
  if (APIdata[0].is_visible === '1'){
    return {
      type: actionTypes.RECEIVE_NEIGHBORHOOD_DETAIL,
      data: APIdata
    }
  }
  else{
    return {
      type: actionTypes.NOT_RECEIVE_NEIGHBORHOOD_DETAIL
    }
  }
}

function receiveSiblings(APIdata) {
  return {
    type: actionTypes.RECEIVE_SIBLINGS,
    data: APIdata.data
  }
}

function receiveNotIn(APIdata) {
  return {
    type: actionTypes.RECEIVE_NOT_IN_LIST,
    list: APIdata.data
  }
}

function receiveDetail(APIdata) {
  return {
    type: actionTypes.RECEIVE_DETAIL,
    property: APIdata
  }
}

function receiveRelated(APIdata) {
  return {
    type: actionTypes.RECEIVE_RELATED,
    related: APIdata.data
  }
}

function receiveImportant(APIdata) {
  return {
    type: actionTypes.RECEIVE_IMPORTANTS,
    list: APIdata.data
  }
}

function receiveRelevants(APIdata, id) {
  return {
    type: actionTypes.RECEIVE_RELEVANTS,
    list: APIdata.data,
    id: id
  }
}

function loadingDetail() {
  return {
    type: actionTypes.LOADING_DETAIL
  }
}

export const loadPropertyTypes = () => {
  return {
    type: actionTypes.LOAD_PROPERTY_TYPES
  }
}

export const loadPropertyTypesByOperation = () => {
  return (dispatch, getStore) => {
    dispatch(loadPropertyTypes())
    let params = dispatch(fetchFilteredPropertyTypes())
    api.fetchPropertieTypes(params)
      .then((data) => dispatch(receivePropertyTypes(data)))
  }
}


export const receivePropertyTypes = (types) => {
  return {
    type: actionTypes.RECEIVE_PROPERTY_TYPES,
    types
  }
}

export const receiveOperationTypes = (operations) => {
  return {
    type: actionTypes.RECEIVE_OPERATION_TYPES,
    operations
  }
}

export const setModalStatus = (modal) => {
  return {
    type: actionTypes.SET_MODALSTATUS,
    modal
  }
}

export const setInfoType = (value) => {
  return {
    type: actionTypes.SET_INFOTYPE,
    value
  }
}

export const addPlacesInfo = (places) => {
  return {
    type: actionTypes.SET_PLACES,
    places
  }
}

export const saveOrder = (value) => {
  return {
    type: actionTypes.SAVE_ORDER,
    value
  }
}

export const setStreetViewStatus = (value) => {
  return {
    type: actionTypes.SAVE_STREETVIEW_STATUS,
    value
  }
}

export const loadLandings = () => {
  return (dispatch, getStore) => {
    // dispatch(setVentureId());

    dispatch(redirectWithParams(getStore()))
    // dispatch(load(urls.PROPERTIES));
  }
}

export const loadProperties = (store) => {
	var search = ''
	var sb = store.searchBar

	var operationTypes = store.propiedades.operation_types
	var propertyTypes = store.propiedades.property_types
	var administrativeAreas = sb.all_administrative_areas

	if (sb.operation_type.length) {
		if (sb.operation_type[0].name) {
			search += sb.operation_type[0].name
		}
		else {
			var selectedOperationType = operationTypes.filter(ot => ot.id === sb.operation_type[0].id)
			search += selectedOperationType.length ? selectedOperationType[0].name : ''
		}
	}

	if (sb.property_type.length) {
		search += search.length ? ' de ' : ''

		if (sb.property_type[0].name) {
			search += sb.property_type[0].name
		}
		else {
			var selectedPropertyType = propertyTypes.filter(ot => ot.id === sb.property_type[0].id)
			search += selectedPropertyType.length ? selectedPropertyType[0].name : ''
		}
	}

	if (sb.administrative_areas_selected.length) {
		var selectedAreas = sb.administrative_areas_selected.filter(a => typeof a.label ==='string')

		if (selectedAreas.length) {
			var selectedAreasNames = selectedAreas.map(a => {
				var area = a.label

				switch (a.type) {
		      case 'zone': area += ' (zona)'; break
		      case 'locality': area += ' (localidad)'; break
		      case 'district': area += ' (distrito)'; break
		      case 'neighborhood': area += ' (barrio)'; break
		      default: area += ' (' + a.type + ')'
		    }

				return area
			})

			if (selectedAreasNames.length) {
				search += search.length ? ' en ' : ''
				search += selectedAreasNames.join(', ')
			}
		}
	}

  return {
    type: actionTypes.LOAD_PROPERTIES,
		search: search
  }
}

function redirectWithParams (store) {
  let nq = JSON.stringify(pick(paramsForProperties(store)))
  browserHistory.push('/propiedades?q='+JSON.stringify(pick(paramsForProperties(store))))
  return {
    type: actionTypes.VENTURES_LOADING
  }
}

function setPhone(cat, sub, store) {
  let value = tel.TEL_RESIDENTIAL
  if (sub){
    switch (sub) {
      case 'sanisidro': value = tel.TEL_SANISIDRO  ; break
      case 'centro'   : value = tel.TEL_RESIDENTIAL; break
      case 'nordelta' : value = tel.TEL_NORDELTA   ; break
      case 'palermo'  : value = tel.TEL_PALERMO    ; break
      case 'puertos'  : value = tel.TEL_PUERTOS    ; break
      case 'pilar'    : value = tel.TEL_PILAR      ; break
      case 'escobar'  : value = tel.TEL_ESCOBAR    ; break
      default         : console.log('Subsidiary ', sub, ' not found/ready yet')
    }
  }
  else {
    if (cat == 'industrias'){
      value = tel.TEL_INDUSTRIES
    }
    else {
      value = tel.TEL_HOME
    }
  }
  return {
    type: actionTypes.SET_PHONE,
    value
  }
}

function error(APIdataerr) {
  return {
    type: actionTypes.ERROR,
    error: APIdataerr
  }
}



// WEBPACK FOOTER //
// ./src/actions/propiedades.js